module.exports = __webpack_public_path__ + "img/credit_mastercard_icon.332ce98d.png";